import { render, staticRenderFns } from "./PublishStep.vue?vue&type=template&id=1a39dabc&scoped=true"
import script from "./PublishStep.vue?vue&type=script&lang=js"
export * from "./PublishStep.vue?vue&type=script&lang=js"
import style0 from "./PublishStep.vue?vue&type=style&index=0&id=1a39dabc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a39dabc",
  null
  
)

export default component.exports